"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentStatus = void 0;
exports.getAssessmentStatuses = getAssessmentStatuses;
exports.getAssessmentStatusFrom = getAssessmentStatusFrom;
exports.isReopenAssessmentVisible = isReopenAssessmentVisible;
var AssessmentStatus;
(function (AssessmentStatus) {
    AssessmentStatus["Assigned"] = "assigned";
    AssessmentStatus["Open"] = "open";
    AssessmentStatus["NeedsGrading"] = "needs_grading";
    AssessmentStatus["Review"] = "review";
    AssessmentStatus["Closed"] = "closed";
    AssessmentStatus["Paused"] = "paused";
    AssessmentStatus["Done"] = "done";
})(AssessmentStatus || (exports.AssessmentStatus = AssessmentStatus = {}));
function getAssessmentStatuses() {
    return [
        AssessmentStatus.Assigned,
        AssessmentStatus.Open,
        AssessmentStatus.NeedsGrading,
        AssessmentStatus.Review,
        AssessmentStatus.Closed,
        AssessmentStatus.Paused,
        AssessmentStatus.Done,
    ];
}
function getAssessmentStatusFrom(value) {
    return getAssessmentStatuses().find(function (type) { return type === value; });
}
var reopenEligibleStatus = [
    AssessmentStatus.Done,
    AssessmentStatus.Review,
    AssessmentStatus.NeedsGrading,
];
function isReopenAssessmentVisible(assessmentStatus) {
    return !!reopenEligibleStatus.find(function (status) { return status === assessmentStatus; });
}
